import { logger } from '@lessonup/logging-classic';
import { DemoLesson } from '@lessonup/teaching-core';
import { DomainRuleSuggestion } from '@lessonup/typescript-core/domain';
import { useDeepCompareEffectNoCheck, useContextGenerator } from '@lessonup/typescript-core/ui';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppServices } from '../../../components/appServices/AppServicesContext';
import { loggedInUser } from '../../../redux/selectors';

type PagesLinkingToChildPicker = 'school_picker' | 'email_domain_suggestion';
export interface Context {
  domainRuleSuggestions: DomainRuleSuggestion[];
  demoLesson?: DemoLesson;
  pickChildSource: PagesLinkingToChildPicker | undefined;
  setPickChildSource: (page: PagesLinkingToChildPicker) => void;
  email?: string;
  setEmail: (email?: string | undefined) => void;
}

const RegistrationContext = React.createContext<Context | undefined>(undefined);

export const RegistrationContextProvider: React.FC<React.PropsWithChildren> = (props) => {
  const [domainRuleSuggestions, setDomainRuleSuggestions] = useState<DomainRuleSuggestion[]>([]);
  const [email, setEmail] = useState<string | undefined>();
  const [pickChildSource, setPickChildSource] = useState<PagesLinkingToChildPicker | undefined>();
  const user = useSelector(loggedInUser());
  const appServices = useAppServices();

  useDeepCompareEffectNoCheck(() => {
    if (!user) return;
    fetchSuggestions();
  }, [user]);

  async function fetchSuggestions() {
    try {
      const suggestions = await appServices.domainRules.getSuggestions();
      setDomainRuleSuggestions(suggestions);
    } catch (error) {
      logger.error(error);
    }
  }

  return (
    <RegistrationContext.Provider
      value={{ domainRuleSuggestions, demoLesson: undefined, pickChildSource, setPickChildSource, email, setEmail }}
    >
      {props.children}
    </RegistrationContext.Provider>
  );
};

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useRegistrationContext = useContextGenerator(RegistrationContext, 'RegistrationContext');
